export default {"src":"/_next/static/media/turkey.76f8cb0d.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};